import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { fetch } from '@dhl/fetch'
import { getConfig } from '~/config/index.js'
import { type PortalAppConfiguration } from '../../configuration/appconfiguration.js'

type MopinionSendField = {
  field: string
  type: string
  label: string
}

type ThanksPageElement = Record<
  string,
  {
    type: string
    value: string
  }
>

export type MopinionBlockElement = {
  id?: string
  title: string
  show?: boolean
  required?: boolean
  placeholder?: string
  subelements?: Record<string, MopinionBlockElement>
}

export type MopinionBlock = {
  id: string
  typeName: string
  properties: {
    hide_on_init?: boolean
    elements?: Record<string, MopinionBlockElement>
  }
}

export type MopinionResponse = {
  surveyKey: string
  properties: {
    id: string
    name: string
    thanksPage: {
      title: string
      elements: Record<string, ThanksPageElement>
    }
  }
  layout: string[]
  blocks: Record<string, MopinionBlock>
  sendOptions: {
    data: MopinionSendField[]
    domain: string
  }
}

export type SurveyType = Exclude<keyof PortalAppConfiguration['mopinionSurveys'], 'surveyEndpoint'>

export const useMopinionSurvey = (
  survey: SurveyType = 'feedback',
  surveyKey?: string
): UseQueryResult<MopinionResponse> => {
  const { mopinionSurveys } = getConfig()
  const surveyConfig = mopinionSurveys[survey]
  const { surveyEndpoint } = mopinionSurveys

  return useQuery({
    enabled: !!surveyConfig?.token && !!surveyKey,
    queryKey: ['mopinion', surveyEndpoint, surveyKey],
    queryFn: () =>
      fetch<undefined, MopinionResponse>({
        url: `${surveyEndpoint}?key=${surveyKey}`,
      }),
  })
}
